import React from 'react';

import InfoPanelRow from "../../../../../../core/gd-ui/ip-section-row/info-panel-row";
import FieldFormElement from "../../../../../fields3/render/form-elemnent";
import ProjectIconUI5 from "../../../../../gd-components/icons/project/project-icon-ui5";
import FormModel from "../../../../../gd-form/common/form-model-manager";
import UserAssignment_Fields from "../../../model/fields";
import FormFieldError from "../../../../../gd-form/common/form-error/form-field-error";
import ProjectUserFull from "../../../../../model2/project-user/project-user-full";
import FormRowFlex from "../../../../../gd-form/form/form-flex/row";

type Props = {
    form        : FormModel
    userOptions : Options
    projects    : ProjectUserFull[] | null
}

export default class ReassignUserProjects extends React.Component<Props> {

    constructor(props: Props) {
        super(props);
    }

    renderProjectsList = () => {

        const projectsReassignToField = new UserAssignment_Fields().projectReassignUserId

        projectsReassignToField.options = this.props.userOptions

        return (
            <>
                {!_.isEmpty(this.props.projects) && (
                    <div className="ui5-list m-t-10 m-l-25">
                        {
                            _.map(this.props.projects, (p, key: number)=> {
                                const project = gd.session.projects.get(p.id);

                                return (
                                    <div key={key} className="row">
                                        <div className="cell h-40 p-0">
                                            <div className="flex-row-left-center">
                                                <ProjectIconUI5 className="project-icon m-r-10" projectId={project?.id}/>
                                                <div className="ui5-txt-default max-w-300">{project?.name}</div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                )}

                <FormRowFlex label="Re-assign to" width={140} className="m-t-15 p-l-25">
                    <div className="flex-column-left-top">
                        <FieldFormElement field={projectsReassignToField} form={this.props.form}
                                          className="w-300"/>
                        <FormFieldError form={this.props.form} field={projectsReassignToField}/>
                    </div>
                </FormRowFlex>
            </>
        )
    };

    render() {
        if (!this.props.projects || this.props.projects.length < 1) return false;

        return (
            <>
                <div className="ui5-txt-default txt-bold m-t-20 m-l-25">Projects</div>
                {this.renderProjectsList()}
            </>
        )
    }
}
